import { useWorkspaceContext } from "../workspace-provider.js";
/**
 * Access the CASL `AppAbility` for the current user inside the current
 * workspace.
 *
 * Built fresh per workspace context (per ND9 — cache-invalidation bugs on
 * role change are not worth the savings; the ability is < 1ms to build).
 *
 * Prefer `<Can>` for declarative gating in JSX; reach for `useAbility()`
 * only when you need imperative checks (e.g. branch in a callback).
 */
export function useAbility() {
    return useWorkspaceContext().ability;
}
//# sourceMappingURL=use-ability.js.map